import api from '@/api/project';
import pmApi from '@/api/projectMember';
import popup from '@/model/popup';
import push from '@/model/push';
import store from '@/store';
import router from '@/router';
import ProjectPublishTargetSelectorPopupWrappable
  from '@/components/project/ProjectPublishTargetSelectorPopupWrappable.vue';
import ProjectTemplateSelectPopupWrappable
  from '@/components/project/ProjectTemplateSelectPopupWrappable.vue';

export default {
  // eslint-disable-next-line
  getEllipsisMenu({ access, project, onArchiveStateChanged, onRemoved, onProjectLeft, onCompanyDepartmentUpdated }) {
    const items = [];

    if (access.canEditProject()) {
      items.push({
        text: 'Редактировать',
        icon: 'edit',
        route: { name: 'project-edit', params: { projectId: project.id } },
      });
    }

    if (access.canCreateTemplate() && !project.isTemplate) {
      items.push({
        text: 'Создать шаблон',
        icon: 'edit',
        handler: () => { this.duplicate(project, true); },
      });
    }

    if (access.canCopyProject()) {
      items.push({
        text: project.isTemplate ? 'Создать проект' : 'Копировать',
        icon: 'edit',
        handler: () => { this.duplicate(project); },
      });
    }

    if (!project.isArchived && access.canArchiveProject()) {
      items.push({
        text: 'В архив',
        icon: 'archive',
        handler: () => { this.archive(project, true, onArchiveStateChanged); },
      });
    }

    if (project.isArchived && access.canUnarchiveProject()) {
      items.push({
        text: 'Восстановить',
        icon: 'archive',
        handler: () => { this.archive(project, false, onArchiveStateChanged); },
      });
      items.push({
        text: 'Удалить',
        icon: 'trash',
        handler: () => { this.remove(project, onRemoved); },
      });
    }

    if (access.isProjectAuthor() || access.isProjectMember()) {
      items.push({
        text: 'Перенести в компанию',
        icon: 'companies',
        handler: () => { this.changeCompanyDepartment(project, onCompanyDepartmentUpdated); },
      });
    }

    if (access.isProjectMember()) {
      items.push({
        text: 'Покинуть проект',
        icon: 'close3',
        handler: () => { this.leave(project, onProjectLeft); },
      });
    }

    return items;
  },

  async duplicate(project, createTemplate) {
    let question;
    let description;
    let message;
    if (createTemplate) {
      question = 'Созать шаблон проекта?';
      description = 'Будет создана копия проекта, из которой участники, файлы, комментарии и история будут удалены. При этом не будут доступны участники проекта, комментарии и история событий.';
      message = 'Шаблон проекта создан';
    } else if (project.isTemplate) {
      question = 'Создать проект на основе шаблона?';
      description = 'Будут скопированы все задачи (названия, описания, чек-листы), блоки задач, файлы, описание проекта. ~~ Сроки проекта и задач будут сдвинуты.';
      message = 'Проект на основе шаблона создан';
    } else {
      question = 'Создать копию проекта?';
      description = 'Будут скопированы все задачи (названия, описания, чек-листы), блоки задач, описание проекта. ~~ Сроки проекта и задач будут сдвинуты. Комментарии в задачах, файлы и участники {не будут скопированы}.';
      message = 'Копия проекта создана';
    }

    if (!await popup.addConfirm(question, description)) return;

    const companyDepartment = await this.selectDepartment();
    if (companyDepartment === false) return;

    api.duplicate(project.id, { isTemplate: createTemplate, companyDepartment })
      .then(r => {
        router.push({ name: 'project-stages', params: { projectId: r.id } });
        push.add({ text: message });
      });
  },
  // Выбор шаблона в попапе и его применение к пустому проекту.
  // Резолвится true, если шаблон применён, — вызывающий сам перечитывает проект.
  async applyTemplate(project) {
    const template = await popup.add({
      wrappable: true,
      component: ProjectTemplateSelectPopupWrappable,
      params: { project },
    });

    if (!template) return false;

    await api.applyTemplate(project.id, template.id);
    push.add({ text: 'Шаблон применён' });

    return true;
  },
  async archive(project, isArchive, onArchiveStateChanged) {
    if (isArchive && project.numberOfTasks > project.numberOfClosedTasks) {
      const res = await popup.addConfirm('В проекте есть открытые задачи. Вы уверены, что хотите отправить проект в архив? Работа в проекте будет невозможна.');

      if (!res) return;
    }

    api.archive(project.id, isArchive, true).then(onArchiveStateChanged);
  },
  async remove(project, onRemoved) {
    if (await popup.addConfirm(`Вы действительно хотите удалить проект [${project.name}]?`)) {
      api.delete(project.id, true).then(onRemoved);
    }
  },
  async leave(project, onProjectLeft) {
    const res = await popup.addConfirm(`Вы действительно хотите покинуть проект [${project.name}]?`);
    if (!res) return;

    const { user } = store.state.auth;
    const member = project.projectMembers.find(m => m.user.id === user.id);

    if (!member) return; // todo maybe throw err

    await pmApi.delete(member.id, true)
      .then(() => {
        router.push({ name: 'project-list' });
        onProjectLeft();
      });
  },
  async selectDepartment(title = null, hideSelf = false) {
    const departments = store.getters['auth/companyDepartments'];
    console.log(departments);

    if (!departments.length) return Promise.resolve(null);

    const res = await popup.add({
      wrappable: true,
      component: ProjectPublishTargetSelectorPopupWrappable,
      params: { title, hideSelf },
    });

    return Promise.resolve(res);
  },
  async changeCompanyDepartment(project, onCompanyDepartmentUpdated) {
    const companyDepartment = await this.selectDepartment("В какой отдел перенести проект?", true);

    await api.update(project.id, { companyDepartment }, true);
    push.add({ text: 'Проект перенесен' });
    onCompanyDepartmentUpdated();
  }
};
